import React from 'react';

interface TableProps {
  columns: string[];
  data: any[][];
}

const invoiceDocumentTable: React.FC<TableProps> = ({ columns, data }) => {
  return (
    <div>
      <div className="relative ">
        <table className="w-full text-sm text-left text-black dark:text-black">
          <thead className="text-xs text-white sentencecase bg-[#044e97]">
            <tr>
              {columns.map((column, index) => (
                <th key={index} scope="col" className="pl-[4em] py-3 ">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={`${
                  rowIndex % 2 === 0 ? 'bg-white' : 'bg-white dark:bg-gray-800'
                } border-b dark:border-gray-700`}
              >
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={`pl-[4em] py-4 ${
                      cellIndex === 0 ? 'font-medium text-black md:text-[11px] lg:text-[14px]' : ''
                    } whitespace-nowrap dark:text-white`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default invoiceDocumentTable;
